module.exports = __webpack_public_path__ + "static/media/invalid_url.bad9db0b.png";